 

const isAuthenticatedGuard = async (to, from, next) => {
    // console.log({ to, from, next })

     

    return new Promise(() => {

        const token = localStorage.getItem('token');

        if (token) {
            next();
        } else {
            next({ name: 'autenticacion-login' });
        }

    })

}



const loginGuard = async (to, from, next) => {
    console.log({ to, from, next })

    const token = localStorage.getItem('token');

 
    // Si el usuario está autenticado, redirigir a otra página
    if (token) {
        next({ name: 'inscripcion-autorizacion' });
    } else {
        // Si el usuario no está autenticado, permitir el acceso normalmente
        next();
    }
};


// export default isAuthenticatedGuard
export { isAuthenticatedGuard, loginGuard };
